import React from 'react';
import './AiBubble.css';

interface AiBubbleProps {
  position: { x: number; y: number };
  visible: boolean;
  onClick: () => void;
  onClose?: () => void;
  label?: string;
}

const AiBubble: React.FC<AiBubbleProps> = ({
  position,
  visible,
  onClick,
  onClose,
  label = '🧠 解释代码'
}) => {
  if (!visible) return null;

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClick();
  };

  const handleClose = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onClose) onClose();
  };

  return (
    <div 
      className="ai-bubble"
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`
      }}
      onClick={handleClick}
    >
      <span className="ai-bubble-label">{label}</span>
      {onClose && (
        <button className="ai-bubble-close" onClick={handleClose}>
          ×
        </button>
      )}
    </div>
  );
};

export default AiBubble;
